import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";

import { consentTextEN } from "./shared.js";

const contactSalesEN: FormDefinition = {
	signature: "cd505eb636e5e5c7670146a607254bb45609fb83190127c0c5ae4670f901a5de",
	formID: "contact-sales-en",
	schema: z.object({
		"First Name": z.string(),
		"Last Name": z.string(),
		Email: z.string().email(),
		Company: z.string(),
		Language: language,
		"Phone Number": z.string(),
		"Are you looking for a sample pack or a quote? (Or both!)": z.string(),
		"Are you interested in stock pouches, custom pouches, or custom rollstock?":
			z.string(), // "We do it all. Not sure what you need? Just let us know!"
		"Have you had packaging done before?": z.string(),
		"What are you packaging?": z.string(),
		"Do you know the approximate dimensions or weight you're looking for?":
			z.string(),
		"How many units are you looking to order?": z.string(),
		"Are you working with an existing design and/or a designer?": z.string(),
		"Where did you hear about us?": z.string().optional(),
		"Anything else we should know?": z
			.string()
			.optional()
			.describe(
				createCustomSettings({
					textArea: true,
				}),
			),
		consentTextEN,
	}),
	submissionOptions: {
		subject: (formState) => `Contact Sales Form: ${formState["First Name"]}`,
		preamble: "Submitted information",
		postamble:
			"Contact the Web Team if you have any issues with this the data in this email.",
		recipients: ["sales@rootree.ca", "web@rootree.ca"],
	},
	formOptions: {
		strings: {
			submitButton: "Send it in!",
			success:
				"Success! A member of our sales team will be in touch shortly. If you need anything else, feel free to call us at 1-833-ROOTREE (766-8733).",
		},
	},
};
export default contactSalesEN;
